import { Icon, Text } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Utils.Token.ToInt(Spacing, 'stack.nano'),
    borderRadius: Utils.Token.ToInt(BoxRadius, 'md'),
    backgroundColor: Color['brand.tertiary.lightest'],
    paddingVertical: Utils.Token.ToInt(Spacing, 'inset.nano'),
    paddingHorizontal: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
    alignSelf: 'flex-start',
  },
});

export const SignoutButton: React.FC = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleClose = () => {
    navigate('SignOut');
  };

  return (
    <Pressable onPress={handleClose} style={styles.container}>
      <Icon name="Exit" size="xxs" color={Color['brand.tertiary.principal']} />
      <Text color="brand.tertiary.principal">Sair</Text>
    </Pressable>
  );
};
